<template>
  <div class="content-center bg-black">
    <div style="background-color: #CC007A">
      <div class="p-7 flex justify-center items-center">
        <a href="/"><img src="/images/logo_testo.png"/></a>
      </div>
      <div class="p-2 flex justify-center items-center">
        <!-- <span class="text-white text-center font-bold text-3xl">Conserva questo codice coupon<br> effettuando uno screenshot e <br>vieni a trovarci a <br>TRANI in piazzale Colonna il<br> 2, 3 e 4 SETTEMBRE <br>per ricevere uno <br>sconto! </span> -->
        <span class="text-white text-center font-bold text-4xl">Complimenti!<br><br>La tua registrazione è <br>andata a buon fine.<br><br> Continua a seguirci sul canale whatsapp <br> <a style="color: cornflowerblue;" href="https://whatsapp.com/channel/0029VaVTWwp3GJOovIbNA63s">cliccando qui</a> <br>per non perdere i nostri prossimi eventi <br>ricchi di sconti! <br> </span>
      </div>
      <div class="p-2 flex justify-center items-center">
        <vue-barcode style="padding: 50px 20px" v-bind:value="$page.props.flash.success" :options="{ displayValue: true }"></vue-barcode>
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from '@chenfengyuan/vue-barcode'

export default {
  components: {
    VueBarcode,
  },
  data() {
    return {
      options: {},
    }
  },
}
</script>